/******************************************************************************
 *
 * Copyright (c) 2017, the Perspective Authors.
 *
 * This file is part of the Perspective library, distributed under the terms of
 * the Apache License 2.0.  The full license can be found in the LICENSE file.
 *
 */

export async function expandCollapseHandler(regularTable, event) {
    const meta = regularTable.getMeta(event.target);
    const is_collapse = event.target.classList.contains(
        "psp-tree-label-collapse"
    );
    if (event.shiftKey && is_collapse) {
        this._view.set_depth(
            meta.row_header.filter((x) => x !== undefined).length - 2
        );
    } else if (event.shiftKey) {
        this._view.set_depth(
            meta.row_header.filter((x) => x !== undefined).length - 1
        );
    } else if (is_collapse) {
        this._view.collapse(meta.y);
    } else {
        this._view.expand(meta.y);
    }
    this._num_rows = await this._view.num_rows();
    this._num_columns = await this._view.num_columns();
    regularTable.draw();
}
